
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/date-pickers/desktop-date-range-picker",
      function () {
        return require("private-next-pages/x/api/date-pickers/desktop-date-range-picker.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/date-pickers/desktop-date-range-picker"])
      });
    }
  